import * as React from 'react';
import {
	Redirect,
	Route,
	RouteComponentProps,
	RouteProps,
} from 'react-router-dom';
import { RoleTypes } from '../../models';
import { isRequiredRole } from '../../helpers';

export interface IPrivateRoute extends RouteComponentProps {
	component: React.ElementType;
	path: string;
	requiredRoles?: RoleTypes[];
	role: RoleTypes;
	exact?: boolean;
}

export const PrivateRoute: React.FC<IPrivateRoute> = ({
	component: Component,
	requiredRoles,
	role,
	...rest
}) => {
	let render;
	if (isRequiredRole(role, requiredRoles)) {
		render = (props: RouteProps) => <Component {...props} />;
	} else {
		render = () => <Redirect to="/" />;
	}

	return <Route path={rest.path} render={render} />;
};
